import './style.css'

const Tag = (props) => (
    <span className="tag">{props.children}</span>
)

export default Tag
